<template>
  <Modal
    v-model="editAccountModal" class-name="editAccountStyle" :title="$t('key1005421')" width="1200"
    @on-visible-change="editAccountModalChange" :transfer="false" :mask-closable="false">
    <Tabs type="card" @on-tab-remove="delAccount" @on-click="getTabIndex" v-model="tabsValue">
      <TabPane v-for="(tab,index) in tabs" :key="index" :name="index.toString()" :label="tab.accountName">
        <Form :ref="'accountInfo_' + index" :model="accountInfo" :label-width="90" @submit.native.prevent>
          <Row>
            <!--账号名称-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="account" :label="$t('key1005429')" :rules="{required: true, message: $t('key1005426'),trigger: 'blur'}">
                <Input v-model.trim="accountInfo.account" style="width: 240px;"></Input>
              </FormItem>
            </Col>
            <!--账号状态-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="status" :label="$t('key1001522')">
                <i-switch v-model="accountInfo.status" size="large" :true-value="1" :false-value="0">
                  <template #open>{{ $t('key1000462') }}</template>
                  <template #close>{{ $t('key1000463') }}</template>
                </i-switch>
              </FormItem>
            </Col>
            <!--授权状态-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
              v-if="((carrierCode === 'sfsuyun' || logisticsDetails.apiCode === 'miyunoutstore') && accountInfo.authType === '03')
              || accountInfo.authType === '02'">
              <FormItem prop="status" :label="$t('key1005430')">
                <span v-if="accountInfo.authStatus === 1" class="greenColor">{{ $t('key1005436') }}</span>
                <span v-else class="redColor">{{ $t('key1005437') }}</span>
                <Button class="ml20" @click="authorizeBtn(tab)" size="small">
                  {{ accountInfo.authStatus === 1 ? $t('key1005434') : $t('key1005435') }}
                </Button>
              </FormItem>
            </Col>
            <!--carrierParamList的基本信息-->
            <template v-if="accountInfo.carrierParamList && accountInfo.carrierParamList.length >0 && apiType !==1">
              <template v-for="(item, idx) in accountInfo.carrierParamList">
                <template v-if="accountInfo.authType === '02'">
                  <Col span="6" :key="idx" v-if="item.paramType !== 'hide'">
                    <FormItem :prop="item.paramKey" :label="item.paramName + '：'" :key="idx">
                      <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue" clearable></Input>
                      <Input v-if="item.paramType === 'readOnly'" disabled :value="item.paramValue"></Input>
                    </FormItem>
                  </Col>
                </template>
                <template v-if="(accountInfo.authStatus === 0 || accountInfo.authStatus === 2) && accountInfo.authType === '01'">
                  <Col span="6" :key="idx">
                    <FormItem :prop="item.paramKey" :label="item.paramName +'：'" :key="idx" :label-width="100">
                      <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue" clearable></Input>
                    </FormItem>
                  </Col>
                </template>

                <template v-if="accountInfo.authStatus === 0 && accountInfo.authType === '03'">
                  <Col span="8" :key="idx">
                    <FormItem
                      v-if="item.paramType === 'hide'"
                      v-show="false"
                      :prop="item.paramKey"
                      :label="item.paramName +'：'"
                      :key="idx"
                      :label-width="100">
                      <!-- 缓存数据，不显示 -->
                      <span v-if="item.paramType === 'hide'" v-show="false">{{ item.paramValue }}</span>
                    </FormItem>
                    <FormItem
                      v-else-if="item.paramType === 'select'"
                      :prop="item.paramKey"
                      :label="item.paramName + '：'"
                      :key="idx"
                      :label-width="100">
                      <Select v-model.trim="item.paramValue" filterable>
                        <Option v-for="(k,ind) in item.carrierParamDictionaryList" :key="ind" :value="k.itemValue">{{ k.itemName }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem v-else :prop="item.paramKey" :label="item.paramName + '：'" :key="idx" :label-width="120">
                      <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue">
                      </Input>
                    </FormItem>
                  </Col>
                </template>

                <template v-if="accountInfo.authType !== '03' && item.apiType === '0' && apiInterface !== 'API_WINIT_EXPRESS'">
                  <FormItem :label="item.paramKey + '：'" :key="idx" :label-width="100" v-if="item.paramType !== 'hide'">
                    <span :class="accountInfo.authStatus === 0 ? 'redColor' : 'greenColor'">{{ item.paramValue }}</span>
                  </FormItem>
                </template>

              </template>
            </template>
          </Row>
          <!--寄件、揽件、退件地址模板  线下物流才会有-->
          <Row class="addressStyle" v-if="isOnline === 0">
            <Card :bordered="false" dis-hover v-for="(item, idx) in accountInfo.carrierAccountAddressList" :key="idx" class="addressStyle_item">
              <template #title>
                <h2 class="title_center">{{ addressTypeName[item.addressType] }}</h2>
              </template>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <FormItem :label="$t('key1002436')" :prop="`carrierAccountAddressList.${idx}.ymsAddressTemplateId`"
                  :rules="{required: true, message: $t('key1002432'),trigger: 'change'}">
                  <div class="flex align-items-center">
                    <Select
                      @on-change="(val)=>selectChange(val, item.addressType)"
                      @on-open-change="openChange"
                      v-model="accountInfo.carrierAccountAddressList[idx].ymsAddressTemplateId"
                      transfer
                      filterable
                      style="width: 210px;">
                      <Option v-for="(item, index) in addressTemplateData" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                        <span v-html="item.templateName"></span>
                      </Option>
                    </Select>
                    <span class="cursor themeColor ml8 font-size-13" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
                  </div>
                </FormItem>
                <Row type="flex" :gutter="gutterItem" class="font-size-12 mt24" style="margin-left: 23px"
                  v-if="Object.keys(accountInfo.carrierAccountAddressList[idx].addressDetails).length >0">
                  <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                    <span class="basic_title">{{ ele.title + '：' }}</span>
                    <span class="basic_txt" :title="accountInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey]">
                      {{ accountInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey] || '--' }}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Card>
          </Row>
          <!--EU代理人 eDIS物流渠道才会有代理人信息-->
          <Row class="addressStyle" v-if="apiInterface === 'API_EDIS'">
            <Card :bordered="false" dis-hover v-for="(item, idx) in accountInfo.carrierAccountAgent" :key="idx" class="euAgentStyle_item">
              <template #title>
                <h2 class="title_center">{{ $t('key1005438') }}</h2>
              </template>
              <Row type="flex">
                <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                  <FormItem :labelWidth="150" :label="$t('key1005431')" :prop="`carrierAccountAgent.${idx}.name`"
                    :rules="{trigger: 'blur', required: true, message: $t('key1005427')}">
                    <Input v-model.trim="accountInfo.carrierAccountAgent[idx].name"
                      :placeholder='$t("key1000324")' clearable></Input>
                  </FormItem>
                </Col>
                <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                  <FormItem :label="$t('key1005432')" :prop="`carrierAccountAgent.${idx}.phone`"
                    :rules="{trigger: 'blur', required: true, validator: validateMobile()}">
                    <Input v-model.trim="accountInfo.carrierAccountAgent[idx].phone"
                      :placeholder='$t("key1000324")' clearable></Input>
                  </FormItem>
                </Col>
                <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                  <FormItem :label="$t('key1005433')" :prop="`carrierAccountAgent.${idx}.agentAddress`"
                    :rules="{trigger: 'blur', required: true, message: $t('key1005428')}">
                    <Input v-model.trim="accountInfo.carrierAccountAgent[idx].agentAddress"
                      :placeholder='$t("key1000324")' clearable></Input>
                  </FormItem>
                </Col>
              </Row>
            </Card>
          </Row>
        </Form>
      </TabPane>
      <!--搜索账号-->
      <template #extra>
        <Select class="selectStyles" ref="resetSelect" v-if="tabs.length>1" filterable v-model="selectTabs" @on-change="selectValue">
          <Option v-for="(tab, index) in tabs" :value="index + 1" :key="tab.carrierAccountId">{{ tab.accountName }}</Option>
        </Select>
        <!--添加账号-->
        <Button @click="handleTabsAdd" size="small" type="primary" v-show="carrierType === 0">{{ $t('key1002250') }}</Button>
      </template>
    </Tabs>
    <template #footer>
      <Button @click="editAccountModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="saveAccount">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "editAccountModal",
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editAccountModal: false,
      selectTabs: null,
      tabs: [],
      tabsValue: '0',
      tabIndex: 0,
      carrierId: null,
      enableProviderData: [],
      addressTypeName: {
        pickup: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005252'),
        sender: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005251'),
        return: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005253')
      },
      accountInfo: {}, // 账号信息
      isOnline: 0, // 1 线上物流  0 线下物流
      apiInterface: '', // 物流api类型
      addressTypeList: [], //地址类型
      carrierCode: null,
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      carrierType: null,
      apiType: null,
      logisticsDetails: {},
    };
  },
  methods: {
    // 初始化数据
    initAccountData(data, enableProviderData) {
      let v = this;
      v.logisticsDetails = data;
      v.isOnline = data.isOnline;
      v.carrierId = data.carrierId;
      v.apiInterface = data.apiInterface;
      v.carrierCode = data.carrierCode;
      v.carrierType = data.carrierType;
      v.apiType = data.apiType; // // 物流商类型 0:自营仓物流商   1:海外仓物流商
      v.enableProviderData = enableProviderData; // api对接物流商列表的所有数据
      (async () => {
        await v.getAddressTemplateData();
        // 有账号数
        if (data.carrierAccountsLength > 0) {
          await this.getCarrierAccountInfo(data.carrierId);
        }
        // 没有账号数时，调新增账号接口
        else {
          await this.handleTabsAdd();
        }
      })();
    },
    // 获取账号信息
    getCarrierAccountInfo(carrierId) {
      let v = this;
      v.axios.get(api.get_carrierAccount_queryByCarrierId + carrierId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            data.map((item) => {
              item.accountName = item.account;
              if (v.apiInterface === 'API_EDIS') {
                // 判断当前EDIS物流的EU代理人信息是否已经初始化，如果没有前端默认添加初始化信息
                if (!item.carrierAccountAgent) {
                  item.carrierAccountAgent = [
                    {
                      agentAddress: '',
                      carrierAccountAgentId: null,
                      carrierAccountId: null,
                      createdBy: null,
                      createdTime: null,
                      merchantId: null,
                      name: '',
                      phone: '',
                      updatedBy: null,
                      updatedTime: null
                    }
                  ];
                }
              }
            });
            v.tabs = data;
            v.selectValue(1);
            v.editAccountModal = true;
          }
        }
      });
    },

    // 添加账号
    handleTabsAdd() {
      let v = this;
      let index = v.tabs.length + 1;
      let newData = [];
      v.axios.get(api.get_carrierAccount_getCarrierAccount + v.carrierId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003915') + index;
            data.account = name;
            data.accountName = name;
            data.status = 1;
            data.carrierAccountAddressList = [];
            data.carrierAccountAgent = [];
            if (v.isOnline === 0) {
              let addressTypeList = data.addressTypeList;
              if (addressTypeList && addressTypeList.length > 0) {
                addressTypeList.map((item) => {
                  data.carrierAccountAddressList.push({
                    addressType: item,
                    carrierAccountAddressId: null,
                    carrierAccountId: null,
                    ymsAddressTemplateId: null,
                    addressDetails: {}
                  });
                });
              }
            }
            if (v.apiInterface === 'API_EDIS') {
              data.carrierAccountAgent = [{
                agentAddress: '',
                carrierAccountAgentId: null,
                carrierAccountId: null,
                createdBy: null,
                createdTime: null,
                merchantId: null,
                name: '',
                phone: '',
                updatedBy: null,
                updatedTime: null
              }];
            }
            newData.push(data);
          }
          v.tabs = [...v.tabs, ...newData];
          if (v.tabs.length > 0) {
            v.tabs.map((item) => {
              item.show = false;
            });
            let talgIndex = v.tabs.length - 1;
            v.tabsValue = talgIndex + '';
            v.getTabIndex(talgIndex);
            v.editAccountModal = true;
          }
        }
      });
    },

    // 保存账号 index 物流商的第几个账号
    saveAccount() {
      let v = this;
      v.$refs[`accountInfo_${v.tabIndex}`][0].validate((valid) => {
        if (valid) {
          let query = JSON.parse(JSON.stringify(v.accountInfo));
          query.carrierAccountAddressList = v.accountInfo.carrierAccountAddressList.map((item) => {
            let {addressDetails, ...obj} = item;
            return obj;
          });
          v.axios.post(api.post_carrierAccount_save, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.editAccountModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },

    // 删除账号
    delAccount(index) {
      let v = this;
      let g = null;
      let carrierAccountId = v.tabs[index].carrierAccountId;
      v.enableProviderData.forEach((n, i) => {
        if (n.carrierId === v.carrierId) {
          g = i;
        }
      });
      if (!v.tabs[index].status) {
        v.axios.delete(api.delete_carrierAccount + carrierAccountId).then(response => {
          if (response.data.code === 0) {
            v.tabs.splice(index, 1);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            if (g !== null) {
              v.$emit('updateData', true);
            }
            v.editAccountModal = false;
          }
        });
      } else {
        v.tabs.splice(index, 1);
      }
    },

    // 选取账号
    getTabIndex(val) {
      let v = this;
      v.tabIndex = Number(val);
      v.tabs.forEach((i, index) => {
        i.show = Number(val) === index;
      });
      let data = JSON.parse(JSON.stringify(v.tabs));
      v.tabs = data;
      v.accountInfo = v.handleAddressData(data[v.tabIndex]);
      v.$store.commit('carrierAccountId', v.tabs[v.tabIndex].carrierAccountId);
      v.$forceUpdate();
    },
    // 处理地址数据
    handleAddressData(obj) {
      if (obj) {
        let carrierAccountAddressList = obj.carrierAccountAddressList || [];
        if (carrierAccountAddressList.length > 0) {
          carrierAccountAddressList.map((item) => {
            item.addressDetails = {};
            if (item.ymsAddressTemplateId) {
              if (this.addressTemplateData.length > 0) {
                let newList = this.addressTemplateData.filter((ele) => {
                  return ele.ymsAddressTemplateId === item.ymsAddressTemplateId;
                });
                if (newList && newList.length > 0) {
                  item.addressDetails = newList[0];
                  if (this.countrysOriginalData.length > 0) {
                    this.countrysOriginalData.map((talg) => {
                      if (talg.twoCode === newList[0].countryCode) {
                        item.addressDetails.countryCode = talg.cnName;
                      }
                    });
                  }
                }
              }
            }
          });
        }
      }
      return obj;
    },
    // 选择账号
    selectValue(val) {
      if (val) {
        let index = val - 1;
        this.tabsValue = index.toString();
        this.getTabIndex(index);
      }
    },
    // 监听弹窗
    editAccountModalChange(value) {
      if (!value) {
        this.selectTabs = null;
        this.tabs = [];
        this.addressType = '';
        this.tabIndex = 0;
        this.carrierId = null;
        this.enableProviderData = [];
      }
    },
    // 授权
    authorizeBtn(item) {
      let {apiType, carrierCode, apiCode} = this.logisticsDetails;
      let platformId = apiType === 1 ? apiCode : carrierCode;
      this.authorizedOperation(platformId, null, '', 'edit', item);
    },
    // 授权、重新授权需要调申请授权接口重定向到三方授权系统进行操作
    authorizedOperation(platformId, ymsPlatformAccountId = null, authType = '', action = 'edit', item) {
      let v = this;
      v.axios.post(api.post_ymsCarrierAccount_applyAuth, {
        action: action, // 行动(toauth(返回授权地址)、edit(返回表单地址))
        ymsPlatformAccountId: ymsPlatformAccountId, // 授权账号TOKEN流水号
        currentAuthType: authType,
        platformId: platformId,
        carrierId: item.carrierId,
        carrierAccountId: item.carrierAccountId
      }, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            window.open(data.redirectUrl, '_blank');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005425'));
            return false;
          }
        }
      });
    },
    // 新增地址模板
    addAddressTemplateBtn() {
      const {href} = this.$router.resolve({
        path: '/addressLibraryManage',
        query: {
          addressLibraryType: 'add'
        }
      });
      window.open(href, '_blank');
    },
    // 更新地址模板数据
    openChange(value) {
      if (value) {
        this.getAddressTemplateData();
      }
    },
    // 选择地址模板
    selectChange(ymsAddressTemplateId, addressType) {
      if (this.addressTemplateData.length > 0) {
        let newList = this.addressTemplateData.filter((item) => {
          return item.ymsAddressTemplateId === ymsAddressTemplateId;
        });
        if (newList && newList.length > 0) {
          this.accountInfo.carrierAccountAddressList.map((ele) => {
            if (ele.addressType === addressType) {
              ele.addressDetails = newList[0];
              if (this.countrysOriginalData.length > 0) {
                this.countrysOriginalData.map((talg) => {
                  if (talg.twoCode === newList[0].countryCode) {
                    ele.addressDetails.countryCode = talg.cnName;
                  }
                });
              }
            }
          });
          this.$forceUpdate();
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .editAccountStyle {
  .selectStyles {
    width: 130px;
    position: relative;
    top: 0;
    margin-right: 25px;

    /deep/ .ivu-select-selection {
      height: 30px !important;
    }
  }

  .addressStyle {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .addressStyle_item {
      display: flex;
      flex-direction: column;
      min-width: 365px;
      flex: 1;
      margin: 0 10px;
    }

    .euAgentStyle_item {
      width: 100%;
    }

    /deep/ .ivu-card-head {
      padding: 8px 2px;
    }

    /deep/ .ivu-card-body {
      padding: 16px 8px 16px 0;
      min-height: 300px;
    }

    .title_center {
      font-size: 15px;
      color: #333;
      font-weight: bold;
    }
  }

  .ivu-modal-body {
    .ivu-card-body {
      min-height: 300px;

      .basic_item {
        line-height: inherit;
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        .basic_title {
          min-width: initial;
          display: inline-block;
        }

        .basic_txt {
          display: inline-block;
          max-width: 235px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

</style>
